/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { QuestionnaireStrictHttpResponse } from '../../questionnaire-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmitQuestionnaireRequestModel } from '../../models/submit-questionnaire-request-model';
import { SubmitQuestionnaireResponseModel } from '../../models/submit-questionnaire-response-model';

export interface ApiConsumerQuestionnaireSubmitPost$Params {
      body?: SubmitQuestionnaireRequestModel
}

export function apiConsumerQuestionnaireSubmitPost(http: HttpClient, rootUrl: string, params?: ApiConsumerQuestionnaireSubmitPost$Params, context?: HttpContext): Observable<QuestionnaireStrictHttpResponse<SubmitQuestionnaireResponseModel>> {
  const rb = new RequestBuilder(rootUrl, apiConsumerQuestionnaireSubmitPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as QuestionnaireStrictHttpResponse<SubmitQuestionnaireResponseModel>;
    })
  );
}

apiConsumerQuestionnaireSubmitPost.PATH = '/api/consumer/questionnaire/submit';
